import PersonalSettingForm from './PersonalSettingForm';

export default PersonalSettingForm;
